import { getCookie } from "../../utils/cookies";

export const commonInterceptor = async (config) => {
  try {
    // const user = JSON.parse(localStorage.getItem("user"));
    const user = getCookie("user");
    if (user && user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const kycUserInterceptor = async (config) => {
  try {
    const user = getCookie("kyc_user");
    if (user && user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
};